import CoverageCreatedEvent from '@/domains/coverages/events/CoverageCreatedEvent';
import CoverageDeletedEvent from '@/domains/coverages/events/CoverageDeletedEvent';

const CoverageEvents = {
  CoverageCreated: CoverageCreatedEvent,
  CoverageDeleted: CoverageDeletedEvent,
};

export default CoverageEvents;
